import { useEffect } from 'react';

export function useLoadingTimer(callback: () => void) {
  useEffect(() => {
    const timer = setTimeout(callback, 500);
    return () => clearTimeout(timer);
  }, [callback]);
}
